import React, { useCallback } from 'react';
import { Layout, notification } from 'antd';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormLayout } from './form-layout';
import { Header } from './header';
import { submit } from './requests/submit';
import { VALIDATION_SCHEMA } from './constants/validation-schema';
import { INITIAL_VALUES } from './constants/initial-values';
import styles from './styles.module.css';

export function Main() {
  const { t, i18n } = useTranslation();
  const handleSubmit = useCallback(
    // eslint-disable-next-line consistent-return
    async (values) => {
      try {
        return await submit(values);
      } catch (error) {
        notification.error({
          message: t('submit.failed'),
          description: t('submit.failed-message'),
        });
        // throw new Error(error);
        return Promise.reject(error);
      }
    },
    [i18n.language]
  );

  return (
    <Layout className={styles.layout}>
      <Header />
      <Layout.Content className={styles.content}>
        <Formik
          onSubmit={handleSubmit}
          validationSchema={VALIDATION_SCHEMA}
          initialValues={INITIAL_VALUES}
        >
          <FormLayout />
        </Formik>
      </Layout.Content>
    </Layout>
  );
}
